import type { PropsWithChildren } from "react";

import { cn } from "@krea/shared/utils";

import DetailsItem from "../item";

interface DetailsCardProps {
  className?: string;
  title?: string;
}

const DetailsCard = ({
  className,
  title,
  children,
}: PropsWithChildren<DetailsCardProps>) => {
  return (
    <section
      className={cn(
        "details-container bg-white h-full w-full p-4 shadow-sm",
        className,
      )}
    >
      <DetailsItem title={title}>{children}</DetailsItem>
    </section>
  );
};

export default DetailsCard;
